// import {   } from '@angular/common/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import {Observable} from 'rxjs/Observable';

import { environment } from '../../../environments/environment';


@Injectable()
export class HttpService {

    private headers;
    private options;
    private optionsHolding;
    private optiondown;
    private rssToJsonServiceBaseUrl: String = 'https://rss2json.com/api.json?rss_url=';
    base_url = '';

    constructor(private http: HttpClient) {
        this.http = http;

        this.base_url = environment.production ? document.getElementsByTagName('base')[0].href : environment.base_url;
        console.log('basehref', document.getElementsByTagName('base')[0].href)
        if (environment.production) {
            this.base_url = this.RemoveLastDirectoryPartOf(this.RemoveLastDirectoryPartOf(this.base_url));
        }

        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/x-www-form-urlencoded').set('Accept', '*/*');
        this.headers = headers;
        // this.headers = new Headers();
        // this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
        // this.headers.append('Accept', '*/*');

        // const headerHolding = new Headers();
        // headerHolding.append('Content-Type', 'application/x-www-form-urlencoded');

        let headerHolding = new HttpHeaders();
        headerHolding = headerHolding.set('Content-Type', 'application/x-www-form-urlencoded');

        // document.cookie = 'SameSite=None; Secure';
        // this.headers.append('Accept-Encoding', 'gzip');
        // this.options = new RequestOptions({ headers: this.headers, withCredentials: true });
        // this.optionsHolding = new RequestOptions({ headers: headerHolding, withCredentials: true });
        this.options = { headers: this.headers, withCredentials: true };
        this.optionsHolding = { headers: headerHolding, withCredentials: true };

        if (environment.production && environment.moduleEcoportailOnly) {
            const urlPortail = environment.api_url_ecoportail;
            const api_url_ecostat = environment.api_url_ecostat;
            environment.api_url_ecoportail = `${this.base_url}${urlPortail}`;
            // environment.api_url_ecostat = `${this.base_url}${api_url_ecostat}`;
            environment.ip_ecoportail = this.base_url;
            environment.api_url_ecomobile = `${this.base_url}${environment.api_url_ecomobile}`;
        }

        environment.old_api_url = environment.base_url;
        if (environment.production) {
            environment.old_api_url = this.base_url;
            environment.api_dmd = `${environment.api_dmd}`;
        }
        environment.base_url = this.base_url;
        console.log(this.base_url, environment.base_url, environment.api_url_ecoportail);
    }

    public get(url): Observable<any> {
        if (!url) {
            return this.http.get(`${environment.base_url}${environment.api_url}/execute/servlet`, this.options);
        } else {
            return this.http.get(url, { responseType: 'blob' });
        }
    }

    public getMethode(url): Observable<any> {
        return this.http.get(`${environment.base_url}${environment.api_url}${url}`, this.options);
    }

    public checkSessionOpenId(url, data): Observable<any> {
        const option = Object.assign({}, this.options);
        // option['responseType'] = 'text';
        return this.http.post(`${environment.base_url}${environment.api_url}${url}`, data, option);
    }

    public checkSession(login): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/x-www-form-urlencoded').set('Accept', '*/*');

        /*this.headers.append('Cache-Control', 'no-cache');*/
        // this.options = new RequestOptions({ headers: this.headers, withCredentials: true });
        const options = { headers: headers, withCredentials: true };
        return this.http.get(`${environment.base_url}${environment.api_url}/check/session/${login}`, options);
    }

    public post(url, data): Observable<any> {
        return this.http.post(`${environment.base_url}${environment.api_url}/execute/servlet`, data, this.options);
    }

    public postHolding(url, data): Observable<any> {
        return this.http.post(`${environment.old_api_url}${environment.api_url}/execute/servlet`, data, this.optionsHolding);
    }

    public postHoldingAutre(url, data): Observable<any> {
        return this.http.post(`${url}${environment.api_url}/execute/servlet`, data, this.optionsHolding);
    }

    public sendDoc(url, data): Observable<any> {
        return this.http.post(`${environment.base_url}${environment.api_url}/send/document`, data, this.options);
    }

    public put(url, data): Observable<any> {
        return this.http.put(`${environment.base_url}${environment.api_url}/${url}`, data, this.options);
    }

    public delete(url): Observable<any> {
        return this.http.delete(`${environment.base_url}${environment.api_url}/${url}`, this.options);
    }

    public logout(): Observable<any> {
        const option = Object.assign({}, this.options);
        option['responseType'] = 'text';
        return this.http.get(`${environment.base_url}${environment.api_url}/logout`, option);
    }

    public logoutHolding(): Observable<any> {
        return this.http.get(`${environment.old_api_url}${environment.api_url}/logout`, this.options);
    }

    public searchEcoloc(data): Observable<any> {
        return this.http.post(`${environment.base_url}${environment.api_url}/search`, data, this.options);
    }

    parseUrladress = function () {
        const parts = document.URL.slice(7).split('/');
        console.log(parts[0]);
        return 'http://' + parts[0];
    };

    getEcoportail(url, appelDepuisEcorec?): Observable<any> {
        if ((environment.production && appelDepuisEcorec) || appelDepuisEcorec) {
            console.log(`GET ${environment.base_url}${environment.api_url_ecoportail}/${url}`);
            return this.http.get(`${environment.base_url}${environment.api_url_ecoportail}/${url}`, this.options);
        } else {
            return this.http.get(`${environment.api_url_ecoportail}/${url}`, this.options);
        }
    }

    getEcoportailFile(url): Observable<any> {
        const option = Object.assign({}, this.options);
        option['responseType'] = 'text';
        // return this.http.get(`${this.base_url}${environment.api_url_ecoportail}/${url}`, this.options);
        return this.http.get(`${environment.api_url_ecoportail}/${url}`, option);
    }

    postEcoportail(url, data, appelDepuisEcorec?): Observable<any> {
        if ((environment.production && appelDepuisEcorec) || appelDepuisEcorec) {
            console.log(`POST ${environment.base_url}${environment.api_url_ecoportail}/${url}`);
            return this.http.post(`${environment.base_url}${environment.api_url_ecoportail}/${url}`, data, this.options);
        } else {
            return this.http.post(`${environment.api_url_ecoportail}/${url}`, data, this.options);
        }
    }

    public putEcoportail(url, data): Observable<any> {
        return this.http.put(`${environment.api_url_ecoportail}/${url}`, data, this.options);
    }


    getUrlPortail(url, appelDepuisEcorec?) {
        if ((environment.production && appelDepuisEcorec) || appelDepuisEcorec) {
            return `${environment.base_url}${environment.api_url_ecoportail}/${url}`;
        } else {
            return `${environment.api_url_ecoportail}/${url}`;
        }
    }

    buildUrlEcoPortail(url) {
        return `${environment.api_url_ecoportail}/${url}`;
    }

    getRss(url): Observable<any> {
        // const option = new RequestOptions({ headers: this.headers });
        const option = { headers: this.headers };
        return this.http.get(`${this.rssToJsonServiceBaseUrl}${url}`, option);
    }

    getFile(url): Observable<any> {
        const headers = new HttpHeaders();
        headers.append('Accept', '*/*');
        // Utiliser le responseType: 'blob' pour obtenir les données sous forme de Blob
        return this.http.get(url, { headers: headers, responseType: 'blob' });
    }

    getHtml(url): Observable<any> {
        // const headers = new Headers();
        // headers.append('Content-Type', 'application/x-www-form-urlencoded');
        // headers.append('Access-Control-Allow-Origin', '*');
        // headers.append('Accept', '*/*');

        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Access-Control-Allow-Origin', '*')
            .set('Accept', '*/*');
        // const option = new RequestOptions({ headers: headers });
        const option = { headers: headers };
        return this.http.get(`${url}`, option);
    }

    getEcomobile(url): Observable<any> {
        if (environment.production && environment.moduleEcoportailOnly) {
            console.log(`${environment.api_url_ecomobile}/${url}`)
            return this.http.get(`${environment.api_url_ecomobile}/${url}`, this.options);
        } else {
            return this.http.get(`${environment.base_url}${environment.api_url_ecomobile}/${url}`, this.options);
        }

    }

    postEcomobile(url, data): Observable<any> {
        if (environment.production && environment.moduleEcoportailOnly) {
            console.log(`${environment.api_url_ecomobile}/${url}`)
            return this.http.post(`${environment.api_url_ecomobile}/${url}`, data, this.options);
        } else {
            return this.http.post(`${environment.base_url}${environment.api_url_ecomobile}/${url}`, data, this.options);
        }
    }
    getURL(url): Observable<any> {
        return this.http.get(`${url}`, this.options);
    }

    postURL(url, data, option?): Observable<any> {
        const headers = new HttpHeaders();
        // headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', '*/*');
        const optionsRequest = option ? { headers: headers, withCredentials: true } : this.options;
        return this.http.post<any>(url, data, optionsRequest);
    }


    public postURLNotForm(url, data, option): Observable<any> {
        return this.http.post(`${url}`, data, this.options);
    }

    RemoveLastDirectoryPartOf(the_url) {
        const the_arr = the_url.split('/');
        the_arr.pop();
        return (the_arr.join('/'));
    }

    postPaiement(url, data): Observable<any> {
        // const headers = new Headers();
        // headers.append('Content-Type', 'application/x-www-form-urlencoded');
        // headers.append('Access-Control-Allow-Origin', '*');
        // headers.append('Accept', '*/*');
        // const option = new RequestOptions({ headers: headers });

        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Access-Control-Allow-Origin', '*')
            .set('Accept', '*/*');
        const option = { headers: headers };
        return this.http.post(`${url}`, data, option);
    }
}

